import { useDispatch, useSelector } from 'react-redux';
import { forwardRef, useImperativeHandle } from 'react';

import { RootState } from 'src/store/store';
import { TabsContent } from '../../AddContact';
import TextArea from '../../../../UI/forms/TextArea';
import SelectInput from 'src/components/UI/forms/Select';
import { createContactForm } from 'src/store/blackbook/createContactSlice';

const ProspectNotes = forwardRef((_props, ref: TabsContent['ref']) => {
  const dispatch = useDispatch();
  const data = useSelector((state: RootState) => state.createContactFormSlice.data);

  useImperativeHandle(ref, () => ({
    async handleValidation() {
      return true
    }
  }));

  return (
    <div className="container-fluid px-3 mt-3">
      <TextArea
        title="General note"
        value={`${data.note ? data.note : ''}`}
        placeHolder="Type here..."
        /* @ts-ignore */
        onChange={(val) => dispatch(createContactForm.setField('note', val, ''))}
      />
      <TextArea
        placeHolder="Type here..."
        title="Dietary and health note"
        value={`${data?.data?.health_note || ''}`}
        /* @ts-ignore */
        onChange={(val) => dispatch(createContactForm.setField('health_note', val))}
      />

      <SelectInput
        /* @ts-ignore */
        onChange={(e: string) => dispatch(createContactForm.setField('source', e))}
        options={[
          { value: 'source-1', label: 'Source 1' },
          { value: 'source-2', label: 'Source 2' },
          { value: 'source-3', label: 'Source 3' },
          { value: 'source-4', label: 'Source 4' },
        ]}
        value={`${data?.data?.source || ''}`}
        placeholder="Source"
      />
    </div>
  );
});

export default ProspectNotes;
